import axios from "axios";

const scoringApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export const fetchClubs = async (callback) => {
  await scoringApi
    .get("/clubInformation")
    .then((res) => {
      if (res.status === 200) {
        callback({ success: true, data: res.data });
      } else {
        callback({ success: false });
      }
    })
    .catch(() => {
      callback({ success: false });
    });
};

export const fetchFitters = async (callback) => {
  await scoringApi
    .get("/fitters")
    .then((res) => {
      if (res.status === 200) {
        callback({ success: true, data: res.data });
      } else {
        callback({ success: false });
      }
    })
    .catch(() => {
      callback({ success: false });
    });
};

export const fetchLocations = async (callback) => {
  await scoringApi
    .get("/locations")
    .then((res) => {
      if (res.status === 200) {
        callback({ success: true, data: res.data });
      } else {
        callback({ success: false });
      }
    })
    .catch(() => {
      callback({ success: false });
    });
};

export const fetchGolfBalls = async (callback) => {
  await scoringApi
    .get("/golfBalls")
    .then((res) => {
      if (res.status === 200) {
        callback({ success: true, data: res.data });
      } else {
        callback({ success: false });
      }
    })
    .catch(() => {
      callback({ success: false });
    });
};

export const scoringApiConnectionCheck = async (callback) => {
  await scoringApi
    .get("/checkScoringConnection")
    .then((res) => {
      if (res.status === 200) {
        callback(true);
      } else {
        callback(false);
      }
    })
    .catch(() => {
      callback(false);
    });
};

export const getScore = async (data, shafts, family, clubType, clubSubTypes) => {
  try {
    const requestBody = {
      ...data,
      clubSubTypes: clubSubTypes || [],
    };

    const response = await scoringApi.post("/score", requestBody, {
      params: {
        shafts: shafts,
        family,
        clubType,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (err) {
    console.log(
      "Issue with scoring api : " +
        err.response.data.msg +
        " " +
        err.response.data.error.message
    );
    return false;
  }
};

export const startFitting = async (fittingStartedSessionId) => {
  try {
    var data = {};
    data.fittingStartedSessionId = fittingStartedSessionId
    data.fitterName = localStorage.getItem("fitterName");
    data.locationId = localStorage.getItem("locationId");
    data.rightHanded = localStorage.getItem("rightHanded");
    data.handicap = localStorage.getItem("handicap");

    const response = await scoringApi.post("/startFitting", data);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

export const submitFitting = async (shaftPurchased, headPurchased, ballPurchased) => {
  try {
    var data = JSON.parse(localStorage.getItem("sessionData"));
    data.shaftPurchased = shaftPurchased;
    data.headPurchased = headPurchased;
    data.ballPurchased = ballPurchased;
    data.sessionId = localStorage.getItem("sessionId");
    data.fittingStartedSessionId = localStorage.getItem("fittingStartedSessionId");
    data.fitterName = localStorage.getItem("fitterName");
    data.locationId = localStorage.getItem("locationId");
    data.rightHanded = localStorage.getItem("rightHanded");
    data.gender = localStorage.getItem("gender");
    data.handicap = localStorage.getItem("handicap");

    const response = await scoringApi.post("/submitFitting", data);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};
